import './Device.css'
import {DeviceFrameset} from "react-device-frameset";
// import 'react-device-frameset/styles/marvel-devices.min.css'
import {Avatar, Text} from "@mantine/core";
import {ArrowLeft, Camera, DotsVertical, Microphone, MoodSmile, Paperclip, Phone, Video} from "tabler-icons-react";

export function Device() {
    return (
        <DeviceFrameset device="Nexus 5" color="black">
            <div className={"device-body"}>
                <div className={"device-whatsapp-status-bar"}>
                    <div className="device-whatsapp-status-bar-profile">
                        <ArrowLeft color={"white"}/>
                        <Avatar src={require("./../../../../../../assets/img/salesCode.JPG")} radius={"xl"}/>
                        <Text color={"white"}>SalesCode.ai</Text>

                    </div>
                    <div className="device-whatsapp-status-bar-actions">
                        <Video color={"white"}/>
                        <Phone fontWeight={"600"} fill="white" color={"white"}/>
                        <DotsVertical color={"white"}/>
                    </div>
                </div>

                <div className={"device-whatsapp-footer"}>
                    <div className={"device-whatsapp-footer-left"}>
                        <div className={"device-whatsapp-footer-input-left-icons"}>
                            <MoodSmile size={16} color={"gray"}/>
                            <Text size={"sm"} color={"gray"}>Message</Text>
                        </div>
                        <div className={"device-whatsapp-footer-input-right-icons"}>
                            <Paperclip size={16} color={"gray"}/>
                            <Camera size={16} color={"gray"}/>
                        </div>


                    </div>

                    <div className={"device-whatsapp-footer-right"}>
                        <Microphone size={10} color={"white"}/>
                    </div>
                </div>
            </div>
        </DeviceFrameset>
    )
}
